import Loader from 'components/partials/loader/loader';
import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import { useUserActivity } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/hooks/use-user-activity';
import { getUserActivityTableSettings } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/tabs/user-activity-tab.config';

import Icons from 'assets/icons';

interface UserActivityTabProps {
  insightId: string | number | undefined;
}

const renderStatisticItem = (
  label: string,
  count: number,
  total: number,
): React.JSX.Element => (
  <div className="text-gray-600">
    <span className="font-semibold">{label}: </span>
    <span>{count}</span>
    <span>/{total}</span>
  </div>
);

const UserActivityTab = ({
  insightId,
}: UserActivityTabProps): React.JSX.Element => {
  const { users, loading, error, totalUsers, viewedCount, downloadedCount } =
    useUserActivity({ insightId });

  const columns = getUserActivityTableSettings();

  if (error) {
    return (
      <div className="p-8 text-center text-red-500">
        Error loading user activity. Please try again.
      </div>
    );
  }

  if (!users.length && !loading) {
    return (
      <EmptySpaceContent
        image={<Icons.EmptyImage customClass="w-[210px] h-[210px]" />}
        text="No users have been assigned yet"
      />
    );
  }

  return (
    <div className="relative">
      <Loader loading={loading} customClass="!bg-white" fullScreen={false} />
      <div className="flex gap-3 mt-5 mb-3">
        {renderStatisticItem('Viewed', viewedCount, totalUsers)}
        {renderStatisticItem('Downloaded', downloadedCount, totalUsers)}
      </div>
      <TableComponent
        columns={columns}
        data={users}
        customHeight="max-h-[500px]"
        pagination={false}
        showingRecordsTextIsOn={false}
        viewByAmountSelectIsOn={false}
        isLoading={loading}
      />
    </div>
  );
};

export default UserActivityTab;
